/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from 'react';
import { Grid, Box, Typography, Direction } from '@mui/material';
import ReactToPrint from 'react-to-print';
import _ from 'lodash';
import { fonts, themes } from '../../../../themes/themes';
import cbLogo from '../../../../../assets/images/CB_logo.png';
import moment from 'moment';
import './PaySlipContent.css';
import { getAmount } from '../../../../configs/utils';
import { useAppSelector } from '../../../../../infra/hooks';
import { useTranslate } from '../../../../../hooks';
import {
  baseDateFormatting,
  baseMonthYearFormatting,
  baseTimeFormatting,
  convertUtcToDate,
  defaultDateFormatting,
} from '../../../../helper';
import { DateField } from '../../../../../components';

interface ModalProps {
  employeeName?: string;
  employeeDesignation?: string;
  payslipData?: any;
  staffId?: number;
  closeModal?: any;
  currency?: string;
}

const PaySlipContent = ({
  employeeDesignation,
  currency,
  employeeName,
  staffId,
  payslipData,
  closeModal,
}: ModalProps) => {
  const { translate, dir } = useTranslate();
  const trans: any = translate;
  const [allBenefits, setAllBenefits] = useState<any>([]);
  const [checkAllBenefits, setCheckAllBenefits] = useState(true);

  const [allAllowances, setAllAllowances] = useState<any>([]);
  const [allAdditions, setAllAditions] = useState<any>([]);
  const [allempClaims, setAllEmpClaims] = useState<any>([]);
  const [allDeductions, setAllDeductions] = useState<any>([]);
  const [allTaxes, setAllTaxes] = useState<any[]>([]);

  const [taxempdedution, setTaxempdedution] = useState<number | undefined>();
  const [emploan, setEmpLoan] = useState<number | undefined>();
  const [netoffcycle, setnetOffCycle] = useState<number | undefined>();

  const payslip_pdf: any = useRef(null);

  const reactToPrintContent = React.useCallback(() => {
    return payslip_pdf.current;
  }, [payslip_pdf.current]);

  const reactToPrintTrigger = React.useCallback(() => {
    return (
      <Box className="download_box">
        <i
          className="las la-download"
          style={{
            fontSize: '16px',
            color: themes.blackDefault,
          }}
        />{' '}
      </Box>
    );
  }, []);

  useEffect(() => {
    if (payslipData) {
      const salary_components: any = JSON.parse(payslipData.salary_components);
      const additions = JSON.parse(payslipData?.additions);
      const deductions = JSON.parse(payslipData?.deductions);
      const govtTaxes = JSON.parse(payslipData?.govt_taxes);
      const empClaims = JSON.parse(payslipData?.emp_claim);

      const Taxemployeededuction = JSON.parse(
        payslipData?.tax_employee_deductions,
      );
      setTaxempdedution(Taxemployeededuction);
      const otherNetoccCycleAmount = JSON.parse(payslipData?.net_off_cycle);
      setnetOffCycle(otherNetoccCycleAmount);
      const EmployeeLoan = JSON.parse(payslipData?.loan);
      setEmpLoan(EmployeeLoan);
      const arr: any = govtTaxes?.length > 0 ? Object.entries(govtTaxes) : [];

      setAllTaxes(arr);
      setAllAditions(additions);
      setAllEmpClaims(empClaims);
      setAllAllowances(salary_components?.allowances);
      setAllBenefits(salary_components?.other_allowances);

      if (salary_components?.other_allowances?.length > 0) {
        const chk: any = salary_components?.other_allowances?.filter(
          (o: any) => {
            const amount = Object.values(o).toString();
            return Number(amount) > 0;
          },
        );
        if (chk.length) {
          setCheckAllBenefits(true);
        } else {
          setCheckAllBenefits(false);
        }
      } else if (salary_components?.other_allowances?.length == 0) {
        setCheckAllBenefits(false);
      }
      setAllDeductions(deductions);
      if (JSON.parse(payslipData?.loss_of_pay) > 0) {
        setAllDeductions((prevState: any) => [
          ...prevState,
          { name: 'Loss of Pay', amount: JSON.parse(payslipData?.loss_of_pay) },
        ]);
      }
    }
  }, [payslipData]);

  const companyLogo = useAppSelector(
    (state) => state.employeeCompanySlice.logo,
  );

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Grid container>
            <Grid
              item
              xs={12}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-end',
                justifyContent: 'right',
              }}
            >
              <ReactToPrint
                content={reactToPrintContent}
                documentTitle={`${employeeName}-${new Date().toDateString()}`}
                trigger={reactToPrintTrigger}
              />
              <Box style={{ marginRight: '1em' }} />
              <Box className="download_box" onClick={closeModal}>
                <i
                  className="las la-times"
                  style={{
                    fontSize: '16px',
                    color: themes.blackDefault,
                  }}
                />{' '}
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          ref={payslip_pdf}
          style={{
            padding: '0 1em',
            direction: (dir as Direction) || 'ltr',
          }}
        >
          <Grid container>
            <Grid item xs={12} style={{ marginTop: '0.5em' }}>
              <Box
                style={{
                  textAlign: 'right',
                }}
              >
                {companyLogo ? (
                  <img
                    src={companyLogo}
                    style={{
                      maxWidth: '8em',
                      width: 'auto',
                      height: 'auto',
                      maxHeight: '3em',
                    }}
                  />
                ) : (
                  <img src={cbLogo} />
                )}
              </Box>
            </Grid>
          </Grid>
          <Grid container>
            <Grid
              item
              xs={12}
              style={{
                display: 'flex',
                alignItems: ' center',
                justifyContent: 'center',
              }}
            >
              <Typography
                style={{
                  color: themes.darkBlue,
                  fontSize: '25px',
                  fontFamily: fonts.fontFamily,
                  fontWeight: 'bold',
                }}
              >
                {trans('Payslip')}
              </Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={6}>
              <Typography
                style={{
                  color: '#8F95B2',
                  fontSize: '0.875em',
                  fontFamily: fonts.fontFamily,
                }}
              >
                {trans('Name')}: {employeeName}
              </Typography>
              <Typography
                style={{
                  color: '#8F95B2',
                  marginTop: '0.25em',
                  fontSize: '0.75em',
                  fontFamily: fonts.fontFamily,
                }}
              >
                {trans('Emp Id')}: {staffId}
              </Typography>
              <Typography
                style={{
                  color: '#8F95B2',
                  marginTop: '0.25em',
                  fontSize: '0.75em',
                  fontFamily: fonts.fontFamily,
                }}
              >
                {trans('Designation')}: {employeeDesignation}
              </Typography>{' '}
            </Grid>

            <Grid
              item
              xs={6}
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'flex-end',
                flexDirection: 'column',
              }}
            >
              <Typography
                style={{
                  color: '#8F95B2',

                  fontSize: '0.75em',
                  fontFamily: fonts.fontFamily,
                  marginTop: '0.25em',
                }}
              >
                {trans('Pay Period')}:{' '}
                <DateField
                  value={payslipData?.period?.start_date}
                  format={baseMonthYearFormatting}
                />
              </Typography>
              <Typography
                style={{
                  color: '#8F95B2',
                  marginTop: '0.25em',
                  fontSize: '0.75em',
                  fontFamily: fonts.fontFamily,
                }}
              >
                {trans('Pay Type')}: {translate(payslipData?.period?.frequency)}
              </Typography>
              <Typography
                style={{
                  color: '#8F95B2',
                  fontSize: '0.75em',
                  fontFamily: fonts.fontFamily,
                }}
              >
                {trans('Hire Date')}:{' '}
                <DateField
                  value={payslipData?.hire_date}
                  format={baseDateFormatting}
                />
              </Typography>
            </Grid>

            {allAllowances?.length > 0 && (
              <Grid item xs={12} style={{ marginTop: '0.5em' }}>
                <Box
                  style={{
                    display: 'flex',
                    height: 'auto',
                    backgroundColor: '#8F95B2',
                    padding: '0.2em',
                    justifyContent: 'space-between',
                  }}
                >
                  <Box>
                    <Typography
                      style={{
                        color: 'white',
                        letterSpacing: '1px',
                        fontFamily: fonts.fontFamily,
                        fontSize: '0.875em',
                        textAlign: 'center',
                      }}
                    >
                      {trans('Salary Details')}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      style={{
                        color: 'white',
                        letterSpacing: '1px',
                        fontFamily: fonts.fontFamily,
                        fontSize: '0.875em',
                        textAlign: 'center',
                      }}
                    >
                      {allAllowances?.length > 0 ? '' : '0.00'}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            )}

            {allAllowances?.length > 0 && (
              <Grid item xs={12}>
                {_.map(allAllowances, function (allowance: any) {
                  const amount = Object.values(allowance).toString();
                  const roundableAmount = Number(amount).toFixed(2);

                  if (Number(roundableAmount) > 0) {
                    return (
                      <Box
                        style={{
                          display: 'flex',
                          height: 'auto',
                          width: 'auto',
                          backgroundColor: '#FFFFFF',
                          justifyContent: 'space-between',
                        }}
                      >
                        <Box
                          style={{
                            marginTop: '0.2em',
                          }}
                        >
                          <Typography
                            style={{
                              color: 'black',
                              letterSpacing: '1px',
                              fontFamily: fonts.fontFamily,
                              fontSize: '0.8em',
                              textAlign: 'center',
                              fontWeight: 'bold',
                            }}
                          >
                            {Number(roundableAmount) > 0 &&
                              trans(Object.keys(allowance).toString())}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            style={{
                              color: 'black',
                              letterSpacing: '1px',
                              fontFamily: fonts.fontFamily,
                              fontSize: '0.8em',
                              fontWeight: 'bold',
                              textAlign: 'center',
                              paddingTop: '0.2em',
                            }}
                          >
                            {Number(roundableAmount) > 0 && roundableAmount}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  }
                })}
              </Grid>
            )}

            {/* Additional Benefits */}

            {allBenefits?.length > 0 && (
              <Grid item xs={12}>
                <Box
                  style={{
                    display: 'flex',
                    height: 'auto',
                    backgroundColor: '#8F95B2',
                    padding: '0.2em',
                    justifyContent: 'space-between',
                  }}
                >
                  <Box>
                    <Typography
                      style={{
                        color: 'white',
                        letterSpacing: '1px',
                        fontFamily: fonts.fontFamily,
                        fontSize: '0.875em',
                        textAlign: 'center',
                      }}
                    >
                      {trans('Additional Benefits')}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      style={{
                        color: 'white',
                        letterSpacing: '1px',
                        fontFamily: fonts.fontFamily,
                        fontSize: '0.875em',
                        textAlign: 'center',
                      }}
                    >
                      {checkAllBenefits ? '' : '0.00'}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            )}

            {allBenefits?.length > 0 && (
              <Grid item xs={12}>
                {_.map(allBenefits, function (benefit: any) {
                  const amount = Object.values(benefit).toString();
                  const roundableAmount = Number(amount).toFixed(2);
                  if (Number(roundableAmount) > 0) {
                    return (
                      <Box
                        style={{
                          display: 'flex',
                          height: 'auto',
                          width: 'auto',
                          backgroundColor: '#FFFFFF',

                          justifyContent: 'space-between',
                        }}
                      >
                        <Box
                          style={{
                            marginTop: '0.2em',
                          }}
                        >
                          <Typography
                            style={{
                              color: 'black',
                              letterSpacing: '1px',
                              fontFamily: fonts.fontFamily,
                              fontSize: '0.8em',
                              textAlign: 'center',
                              fontWeight: 'bold',
                              paddingTop: '0.1em',
                            }}
                          >
                            {Object.keys(benefit).toString()}{' '}
                          </Typography>
                        </Box>
                        <Box
                          style={{
                            marginTop: '0.2em',
                          }}
                        >
                          <Typography
                            style={{
                              color: 'black',
                              letterSpacing: '1px',
                              fontFamily: fonts.fontFamily,
                              fontSize: '0.8em',
                              fontWeight: 'bold',
                              textAlign: 'center',
                              paddingTop: '0.1em',
                            }}
                          >
                            {getAmount(roundableAmount)}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  }
                })}
              </Grid>
            )}

            {/* Additions */}

            {allAdditions?.length > 0 && (
              <Grid item xs={12}>
                <Box
                  style={{
                    display: 'flex',
                    height: 'auto',
                    marginTop: '0.2em',
                    backgroundColor: '#8F95B2',
                    padding: '0.2em',
                    justifyContent: 'space-between',
                  }}
                >
                  <Box>
                    <Typography
                      style={{
                        color: 'white',
                        letterSpacing: '1px',
                        fontFamily: fonts.fontFamily,
                        fontSize: '0.875em',
                        textAlign: 'center',
                      }}
                    >
                      {trans('Additions')}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      style={{
                        color: 'white',
                        letterSpacing: '1px',
                        fontFamily: fonts.fontFamily,
                        fontSize: '0.875em',
                        textAlign: 'center',
                      }}
                    >
                      {Number(payslipData?.overtime) > 0 ||
                      (allAdditions?.length > 0 && allAdditions[0]?.amount > 0)
                        ? ''
                        : '0.00'}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            )}

            {/*  {allAdditions?.length > 0 && ( */}
            <Grid item xs={12}>
              {_.map(allAdditions, function (addition: any) {
                if (Number(addition?.amount) > 0) {
                  return (
                    <Box
                      style={{
                        display: 'flex',
                        height: 'auto',
                        width: 'auto',
                        backgroundColor: '#FFFFFF',

                        justifyContent: 'space-between',
                      }}
                    >
                      <Box
                        style={{
                          marginTop: '0.2em',
                        }}
                      >
                        <Typography
                          style={{
                            color: 'black',
                            letterSpacing: '1px',
                            fontFamily: fonts.fontFamily,
                            fontSize: '0.8em',
                            textAlign: 'center',
                            fontWeight: 'bold',
                            paddingTop: '0.1em',
                          }}
                        >
                          {addition?.name}
                        </Typography>
                      </Box>
                      <Box
                        style={{
                          marginTop: '0.2em',
                        }}
                      >
                        <Typography
                          style={{
                            color: 'black',
                            letterSpacing: '1px',
                            fontFamily: fonts.fontFamily,
                            fontSize: '0.8em',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            paddingTop: '0.1em',
                          }}
                        >
                          {addition?.amount
                            ? `${getAmount(addition?.amount)}`
                            : '--'}
                        </Typography>
                      </Box>
                    </Box>
                  );
                }
              })}
              {allempClaims?.length > 0 &&
                _.map(allempClaims, function (claim: any) {
                  if (Number(claim?.amount) > 0) {
                    return (
                      <Box
                        style={{
                          display: 'flex',
                          height: 'auto',
                          width: 'auto',
                          backgroundColor: '#FFFFFF',

                          justifyContent: 'space-between',
                        }}
                      >
                        <Box
                          style={{
                            marginTop: '0.2em',
                          }}
                        >
                          <Typography
                            style={{
                              color: 'black',
                              letterSpacing: '1px',
                              fontFamily: fonts.fontFamily,
                              fontSize: '0.8em',
                              textAlign: 'center',
                              fontWeight: 'bold',
                              paddingTop: '0.1em',
                            }}
                          >
                            {claim?.name}
                          </Typography>
                        </Box>
                        <Box
                          style={{
                            marginTop: '0.2em',
                          }}
                        >
                          <Typography
                            style={{
                              color: 'black',
                              letterSpacing: '1px',
                              fontFamily: fonts.fontFamily,
                              fontSize: '0.8em',
                              fontWeight: 'bold',
                              textAlign: 'center',
                              paddingTop: '0.1em',
                            }}
                          >
                            {claim?.amount
                              ? `${getAmount(claim?.amount)}`
                              : '--'}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  }
                })}
              {/* {netoffcycle !== undefined && netoffcycle > 0 && (
                <Box
                  style={{
                    display: 'flex',
                    height: 'auto',
                    width: 'auto',
                    backgroundColor: '#FFFFFF',

                    justifyContent: 'space-between',
                  }}
                >
                  <Box
                    style={{
                      marginTop: '0.2em',
                    }}
                  >
                    <Typography
                      style={{
                        color: 'black',
                        letterSpacing: '1px',
                        fontFamily: fonts.fontFamily,
                        fontSize: '0.8em',
                        textAlign: 'center',
                        fontWeight: 'bold',
                        paddingTop: '0.1em',
                      }}
                    >
                      {'Other Addition'}
                    </Typography>
                  </Box>
                  <Box
                    style={{
                      marginTop: '0.2em',
                    }}
                  >
                    <Typography
                      style={{
                        color: 'black',
                        letterSpacing: '1px',
                        fontFamily: fonts.fontFamily,
                        fontSize: '0.8em',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        paddingTop: '0.1em',
                      }}
                    >
                      {netoffcycle ? `${getAmount(netoffcycle)}` : '0'}
                    </Typography>
                  </Box>
                </Box>
              )} */}
            </Grid>
            {/* )} */}

            {Number(payslipData?.overtime) && payslipData?.overtime > 0 ? (
              <Grid item xs={12}>
                <Box
                  style={{
                    display: 'flex',
                    height: 'auto',
                    width: 'auto',
                    backgroundColor: '#FFFFFF',

                    justifyContent: 'space-between',
                    marginTop: '0.1em',
                    marginBottom: '0.1em',
                  }}
                >
                  <Box
                    style={{
                      marginTop: '-0.3em',
                    }}
                  >
                    <Typography
                      style={{
                        color: 'black',
                        letterSpacing: '1px',
                        fontFamily: fonts.fontFamily,
                        fontSize: '0.8em',
                        textAlign: 'center',
                        fontWeight: 'bold',
                        paddingTop: '0.5em',
                      }}
                    >
                      {trans('Total OT')}
                    </Typography>
                  </Box>
                  <Box
                    style={{
                      marginTop: '-0.2em',
                    }}
                  >
                    <Typography
                      style={{
                        color: 'black',
                        letterSpacing: '1px',
                        fontFamily: fonts.fontFamily,
                        fontSize: '0.8em',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        paddingTop: '0.5em',
                      }}
                    >
                      {payslipData?.overtime
                        ? `${getAmount(payslipData?.overtime)}`
                        : '--'}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ) : (
              <div style={{ paddingBottom: '0.2em' }} />
            )}

            {/* Deductions */}

            <Grid item xs={12}>
              <Box
                style={{
                  display: 'flex',
                  height: 'auto',

                  backgroundColor: '#8F95B2',
                  padding: '0.2em',

                  justifyContent: 'space-between',
                }}
              >
                <Box>
                  <Typography
                    style={{
                      color: 'white',
                      letterSpacing: '1px',
                      fontFamily: fonts.fontFamily,
                      fontSize: '0.875em',
                      textAlign: 'center',
                    }}
                  >
                    {trans('Deductions')}
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    style={{
                      color: 'white',
                      letterSpacing: '1px',
                      fontFamily: fonts.fontFamily,
                      fontSize: '0.875em',
                      textAlign: 'center',
                    }}
                  >
                    {Number(payslipData?.loan) > 0 ||
                    (allDeductions?.length > 0 && allDeductions[0]?.amount > 0)
                      ? ''
                      : '0.00'}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12}>
              {_.map(allDeductions, function (deduction: any) {
                if (
                  Number(deduction?.amount) &&
                  Number(deduction?.amount) > 0
                ) {
                  return (
                    <Box
                      style={{
                        display: 'flex',
                        height: 'auto',
                        width: 'auto',
                        backgroundColor: '#FFFFFF',

                        justifyContent: 'space-between',
                      }}
                    >
                      <Box
                        style={{
                          marginTop: '0.2em',
                        }}
                      >
                        <Typography
                          style={{
                            color: 'black',
                            letterSpacing: '1px',
                            fontFamily: fonts.fontFamily,
                            fontSize: '0.8em',
                            textAlign: 'center',
                            fontWeight: 'bold',
                            paddingTop: '0.1em',
                          }}
                        >
                          {deduction?.name}
                        </Typography>
                      </Box>
                      <Box
                        style={{
                          marginTop: '0.2em',
                        }}
                      >
                        <Typography
                          style={{
                            color: 'black',
                            letterSpacing: '1px',
                            fontFamily: fonts.fontFamily,
                            fontSize: '0.8em',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            paddingTop: '0.1em',
                          }}
                        >
                          {deduction?.amount
                            ? `-${getAmount(deduction?.amount)}`
                            : '--'}
                        </Typography>
                      </Box>
                    </Box>
                  );
                }
              })}
              {taxempdedution !== undefined && taxempdedution > 0 && (
                <Box
                  style={{
                    display: 'flex',
                    height: 'auto',
                    width: 'auto',
                    backgroundColor: '#FFFFFF',

                    justifyContent: 'space-between',
                  }}
                >
                  <Box
                    style={{
                      marginTop: '0.2em',
                    }}
                  >
                    <Typography
                      style={{
                        color: 'black',
                        letterSpacing: '1px',
                        fontFamily: fonts.fontFamily,
                        fontSize: '0.8em',
                        textAlign: 'center',
                        fontWeight: 'bold',
                        paddingTop: '0.1em',
                      }}
                    >
                      {'Tax'}
                    </Typography>
                  </Box>
                  <Box
                    style={{
                      marginTop: '0.2em',
                    }}
                  >
                    <Typography
                      style={{
                        color: 'black',
                        letterSpacing: '1px',
                        fontFamily: fonts.fontFamily,
                        fontSize: '0.8em',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        paddingTop: '0.1em',
                      }}
                    >
                      {taxempdedution ? `${getAmount(taxempdedution)}` : '0'}
                    </Typography>
                  </Box>
                </Box>
              )}
              {emploan !== undefined && emploan > 0 && (
                <Box
                  style={{
                    display: 'flex',
                    height: 'auto',
                    width: 'auto',
                    backgroundColor: '#FFFFFF',

                    justifyContent: 'space-between',
                  }}
                >
                  <Box
                    style={{
                      marginTop: '0.2em',
                    }}
                  >
                    <Typography
                      style={{
                        color: 'black',
                        letterSpacing: '1px',
                        fontFamily: fonts.fontFamily,
                        fontSize: '0.8em',
                        textAlign: 'center',
                        fontWeight: 'bold',
                        paddingTop: '0.1em',
                      }}
                    >
                      {'Loan'}
                    </Typography>
                  </Box>
                  <Box
                    style={{
                      marginTop: '0.2em',
                    }}
                  >
                    <Typography
                      style={{
                        color: 'black',
                        letterSpacing: '1px',
                        fontFamily: fonts.fontFamily,
                        fontSize: '0.8em',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        paddingTop: '0.1em',
                      }}
                    >
                      {emploan ? `${getAmount(emploan)}` : '0'}
                    </Typography>
                  </Box>
                </Box>
              )}
            </Grid>

            {Number(payslipData?.loan) && Number(payslipData?.loan) > 0 ? (
              <Grid item xs={12}>
                <Box
                  style={{
                    display: 'flex',
                    height: '2em',
                    width: 'auto',
                    backgroundColor: '#FFFFFF',

                    justifyContent: 'space-between',
                  }}
                >
                  <Box
                    style={{
                      marginTop: '-0.2em',
                    }}
                  >
                    <Typography
                      style={{
                        color: 'black',
                        letterSpacing: '1px',
                        fontFamily: fonts.fontFamily,
                        fontSize: '0.8em',
                        textAlign: 'center',
                        fontWeight: 'bold',
                        paddingTop: '0.5em',
                      }}
                    >
                      {trans('Recurring Payment')}
                    </Typography>
                  </Box>
                  <Box
                    style={{
                      marginTop: '-0.2em',
                    }}
                  >
                    <Typography
                      style={{
                        color: 'black',
                        letterSpacing: '1px',
                        fontFamily: fonts.fontFamily,
                        fontSize: '0.8em',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        paddingTop: '0.5em',
                      }}
                    >
                      {payslipData?.loan
                        ? `-${getAmount(payslipData?.loan)}`
                        : '--'}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ) : (
              <div style={{ paddingBottom: '0.2em' }} />
            )}

            {/* Govt Taxes */}

            {allTaxes?.length > 0 && (
              <Grid item xs={12}>
                <Box
                  style={{
                    display: 'flex',
                    height: 'auto',

                    backgroundColor: '#8F95B2',
                    padding: '0.2em',

                    justifyContent: 'space-between',
                  }}
                >
                  <Box>
                    <Typography
                      style={{
                        color: 'white',
                        letterSpacing: '1px',
                        fontFamily: fonts.fontFamily,
                        fontSize: '0.875em',
                        textAlign: 'center',
                      }}
                    >
                      {trans('Govt Taxes')}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      style={{
                        color: 'white',
                        letterSpacing: '1px',
                        fontFamily: fonts.fontFamily,
                        fontSize: '0.875em',
                        textAlign: 'center',
                      }}
                    ></Typography>
                  </Box>
                </Box>
              </Grid>
            )}

            <Grid item xs={12}>
              {allTaxes?.map(([key, value]) => {
                return (
                  <div key={key}>
                    <Box
                      style={{
                        display: 'flex',
                        height: 'auto',
                        width: 'auto',
                        backgroundColor: '#FFFFFF',

                        justifyContent: 'space-between',
                      }}
                    >
                      <Box
                        style={{
                          marginTop: '0.2em',
                        }}
                      >
                        <Typography
                          style={{
                            color: 'black',
                            letterSpacing: '1px',
                            fontFamily: fonts.fontFamily,
                            fontSize: '0.8em',
                            textAlign: 'center',
                            fontWeight: 'bold',
                            paddingTop: '0.1em',
                          }}
                        >
                          {key}
                        </Typography>
                      </Box>
                      <Box
                        style={{
                          marginTop: '0.2em',
                        }}
                      >
                        <Typography
                          style={{
                            color: 'black',
                            letterSpacing: '1px',
                            fontFamily: fonts.fontFamily,
                            fontSize: '0.8em',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            paddingTop: '0.1em',
                          }}
                        >
                          {value ? `-${getAmount(value)}` : '--'}
                        </Typography>
                      </Box>
                    </Box>
                  </div>
                );
              })}
            </Grid>
            {/* Paid Days */}

            <Grid item xs={12} style={{ marginTop: '-0.1em' }}>
              <Box
                style={{
                  display: 'flex',
                  height: 'auto',

                  backgroundColor: '#8F95B2',
                  padding: '0.2em',

                  justifyContent: 'space-between',
                }}
              >
                <Box>
                  <Typography
                    style={{
                      color: 'white',
                      letterSpacing: '1px',
                      fontFamily: fonts.fontFamily,
                      fontSize: '0.875em',
                      textAlign: 'center',
                    }}
                  >
                    {trans('Paid Days')}
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    style={{
                      color: 'white',
                      letterSpacing: '1px',
                      fontFamily: fonts.fontFamily,
                      fontSize: '0.875em',
                      textAlign: 'center',
                    }}
                  >
                    {trans('Days/Hrs')}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                style={{
                  display: 'flex',
                  height: '2em',
                  width: 'auto',
                  backgroundColor: '#FFFFFF',
                  justifyContent: 'space-between',
                }}
              >
                <Box
                  style={{
                    marginTop: '0.2em',
                  }}
                >
                  <Typography
                    style={{
                      color: 'black',
                      letterSpacing: '1px',
                      fontFamily: fonts.fontFamily,
                      fontSize: '0.8em',
                      textAlign: 'center',
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Total Working Days')}{' '}
                  </Typography>
                </Box>
                <Box
                  style={{
                    marginTop: '0.2em',
                  }}
                >
                  <Typography
                    style={{
                      color: 'black',
                      letterSpacing: '1px',
                      fontFamily: fonts.fontFamily,
                      fontSize: '0.8em',
                      fontWeight: 'bold',
                      textAlign: 'center',
                    }}
                  >
                    {/* {moment(
                      convertUtcToDate(
                        payslipData?.period?.start_date,
                        defaultDateFormatting,
                        null,
                        false,
                      ),
                    ).daysInMonth()} */}
                    {payslipData?.total_working_days}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                style={{
                  display: 'flex',
                  height: '2em',
                  width: 'auto',
                  backgroundColor: '#FFFFFF',

                  justifyContent: 'space-between',
                }}
              >
                <Box
                  style={{
                    marginTop: '-0.3em',
                  }}
                >
                  <Typography
                    style={{
                      color: 'black',
                      letterSpacing: '1px',
                      fontFamily: fonts.fontFamily,
                      fontSize: '0.8em',
                      textAlign: 'center',
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Leave Days')}
                  </Typography>
                </Box>
                <Box
                  style={{
                    marginTop: '-0.3em',
                  }}
                >
                  <Typography
                    style={{
                      color: 'black',
                      letterSpacing: '1px',
                      fontFamily: fonts.fontFamily,
                      fontSize: '0.8em',
                      fontWeight: 'bold',
                      textAlign: 'center',
                    }}
                  >
                    {payslipData?.total_leave}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                style={{
                  display: 'flex',
                  height: '2em',
                  width: 'auto',
                  backgroundColor: '#FFFFFF',

                  justifyContent: 'space-between',
                }}
              >
                <Box
                  style={{
                    marginTop: '-0.8em',
                  }}
                >
                  <Typography
                    style={{
                      color: 'black',
                      letterSpacing: '1px',
                      fontFamily: fonts.fontFamily,
                      fontSize: '0.8em',
                      textAlign: 'center',
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Absent Days / UL')}
                  </Typography>
                </Box>
                <Box
                  style={{
                    marginTop: '-0.8em',
                  }}
                >
                  <Typography
                    style={{
                      color: 'black',
                      letterSpacing: '1px',
                      fontFamily: fonts.fontFamily,
                      fontSize: '0.8em',
                      fontWeight: 'bold',
                      textAlign: 'center',
                    }}
                  >
                    {payslipData?.total_absent}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid
              container
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '-0.5em',
              }}
            >
              <Grid item xs={6}>
                <Box
                  style={{
                    display: 'flex',
                    height: '2em',
                    width: '145px',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#8F95B2',
                  }}
                >
                  <Typography
                    style={{
                      color: 'white',
                      fontFamily: fonts.fontFamily,
                      fontSize: '0.9em',
                      textAlign: 'center',
                      padding: '1em',
                    }}
                  >
                    {trans('Total Net Payable')}
                  </Typography>
                </Box>
              </Grid>

              <Grid
                item
                xs={6}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    height: '2em',
                    width: '145px',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'black',
                  }}
                >
                  <Typography
                    style={{
                      color: 'white',
                      fontFamily: fonts.fontFamily,
                      fontSize: '0.875em',
                      textAlign: 'center',
                      padding: '1em',
                    }}
                  >
                    {payslipData?.net_salary
                      ? trans(currency) +
                        ' ' +
                        getAmount(payslipData?.net_salary)
                      : '--'}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
            <Grid
              container
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '1em',
              }}
            >
              <Grid item xs={12}>
                <Typography
                  style={{
                    color: themes.greySubtitle,
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.title,
                    textAlign: 'center',
                    fontStyle: 'italic',
                  }}
                >
                  {trans(
                    'This is system generated document, signature is not required',
                  )}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default PaySlipContent;
